import { render, staticRenderFns } from "./CdnVideo.vue?vue&type=template&id=72917718&"
import script from "./CdnVideo.vue?vue&type=script&lang=js&"
export * from "./CdnVideo.vue?vue&type=script&lang=js&"
import style0 from "./CdnVideo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports